import React from 'react';
import PropTypes from 'prop-types';
import { isEntitled } from 'utils/auth.utils';
import { FEATURE_ENTITLEMENTS } from 'layout/entitleUser/EntitleUser.constants';
import {
  UNSET_ANOMALY_ID,
  FETCH_ANOMALY_METADATA,
  GET_ANOMALY_NOTES,
} from 'layout/adjuster/Adjuster.constants';
import AnomalyDecisionCard from './AnomalyDecisionCard';

// Memoized AnomalyCardItem component moved outside main component
const AnomalyCardItem = React.memo(({
  style,
  highlight,
  anomaly,
  handlers,
  t,
  confirmOrRemoveAnomalyDecision,
  handleOpenAnomalyDescription,
  entitlements,
  setHoveredAnomalyId,
  classes,
}) => {
  if (!anomaly || !anomaly.properties) return null;

  return (
    <div style={style}>
      <div
        className={classes.anomalyCard}
        data-anomaly-id={anomaly.properties.anomalyId}
        onMouseEnter={() => setHoveredAnomalyId(anomaly.properties.anomalyId)}
      >
        <AnomalyDecisionCard
          t={t}
          anomalyTypeOptions={[
            { value: 'hail', label: 'workflowpanel.hail' },
            { value: 'wind', label: 'workflowpanel.wind' },
            { value: 'Nail Pop', label: 'workflowpanel.nailPop' },
            { value: 'Blistering', label: 'workflowpanel.blistering' },
            { value: 'Mechanical', label: 'workflowpanel.mechanical' },
            { value: 'Wear and Tear', label: 'workflowpanel.wearAndTear' },
            { value: 'Other', label: 'workflowpanel.other' },
          ]}
          onTypeChange={handlers.onTypeChange}
          showAnomalyDescription={false}
          isAnomalyDescriptionPresent={false}
          onOpenAnomalyDescription={() => handleOpenAnomalyDescription(anomaly.properties.anomalyId)}
          UNSET_ANOMALY_ID={UNSET_ANOMALY_ID}
          GET_ANOMALY_NOTES={GET_ANOMALY_NOTES}
          isEntitled={isEntitled}
          FEATURE_ENTITLEMENTS={FEATURE_ENTITLEMENTS}
          selectedAnomaly={anomaly}
          getMappedAnomalyType={handlers.getMappedAnomalyType}
          onMarkDamage={confirmOrRemoveAnomalyDecision}
          isFacetClickDisplay={false}
          FETCH_ANOMALY_METADATA={FETCH_ANOMALY_METADATA}
          handleDeleteUserAnomalyOpen={handlers.handleDeleteUserAnomalyOpen}
          confirmOrRemoveAnomalyDecision={confirmOrRemoveAnomalyDecision}
          onIncludeInReport={handlers.onIncludeInReport}
          showIncludeInReport={anomaly.properties.status === 'CONFIRMED' || anomaly.properties.isUserAdded}
          includeInReportChecked={anomaly.properties.includeInReport || false}
          includeInReportDisabled={!isEntitled(entitlements, FEATURE_ENTITLEMENTS.MANAGE_REPORTS)}
          onExpandClick={handlers.onExpandClick}
          highlight={highlight}
          onAnomalyCardHover={(anomalyId) => {
            setHoveredAnomalyId(anomalyId);
          }}
        />
      </div>
    </div>
  );
});

AnomalyCardItem.propTypes = {
  style: PropTypes.shape({}).isRequired,
  highlight: PropTypes.bool,
  anomaly: PropTypes.shape({
    properties: PropTypes.shape({
      anomalyId: PropTypes.string,
      type: PropTypes.string,
      status: PropTypes.string,
      includeInReport: PropTypes.bool,
      isUserAdded: PropTypes.bool,
    }),
  }),
  handlers: PropTypes.shape({
    onTypeChange: PropTypes.func,
    getMappedAnomalyType: PropTypes.func,
    handleDeleteUserAnomalyOpen: PropTypes.func,
    onIncludeInReport: PropTypes.func,
    onExpandClick: PropTypes.func,
    retryScreenshot: PropTypes.func,
  }),
  t: PropTypes.func,
  confirmOrRemoveAnomalyDecision: PropTypes.func,
  handleOpenAnomalyDescription: PropTypes.func,
  entitlements: PropTypes.shape({}),
  setHoveredAnomalyId: PropTypes.func,
  classes: PropTypes.shape({
    anomalyCard: PropTypes.string,
  }),
};

AnomalyCardItem.defaultProps = {
  highlight: false,
  anomaly: null,
  handlers: {},
  t: () => {},
  confirmOrRemoveAnomalyDecision: () => {},
  handleOpenAnomalyDescription: () => {},
  entitlements: {},
  setHoveredAnomalyId: () => {},
  classes: {},
};

export default AnomalyCardItem;
